import React from 'react'

const Check = () => {
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.34124 0.591296C8.49972 0.440421 8.71061 0.357011 8.92941 0.358667C9.14822 0.360322 9.35782 0.446914 9.514 0.60017C9.67017 0.753425 9.7607 0.961358 9.76649 1.18009C9.77227 1.39883 9.69285 1.61125 9.54499 1.77255L5.05624 7.3863C4.97906 7.46943 4.8859 7.53615 4.78234 7.58246C4.67878 7.62877 4.56695 7.65372 4.45353 7.65582C4.3401 7.65792 4.22742 7.63713 4.12222 7.59468C4.01702 7.55224 3.92145 7.48902 3.84124 7.4088L0.864494 4.43205C0.781597 4.3548 0.715107 4.26165 0.668991 4.15815C0.622875 4.05465 0.598077 3.94292 0.596079 3.82963C0.59408 3.71634 0.61492 3.60381 0.657356 3.49875C0.699792 3.39369 0.762955 3.29825 0.843076 3.21813C0.923197 3.13801 1.01864 3.07484 1.1237 3.03241C1.22876 2.98997 1.34129 2.96913 1.45458 2.97113C1.56787 2.97313 1.6796 2.99793 1.7831 3.04404C1.8866 3.09016 1.97975 3.15665 2.05699 3.23955L4.41274 5.59417L8.31987 0.616046C8.3269 0.607385 8.33442 0.599122 8.34237 0.591296H8.34124Z"
        fill="#151F31"
      />
    </svg>
  )
}

export default Check
